import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e65635a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "block text-gray-500 text-sm font-normal text-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircleLoader = _resolveComponent("CircleLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["group flex items-center font-normal mt-1 w-full shadow-sm justify-between rounded-md bg-white border border-gray-200 px-3 text-sm truncate leading-5 focus:outline-none transition ease-in-out duration-300", _ctx.dynamiClasses])
    }, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            class: _normalizeClass(["-mr-1 ml-2 h-5 w-5 transform duration-300 ease-in-out absolute right-2 text-gray-400 group-hover:text-blue-500", _ctx.open ? ' rotate-180' : 'rotate-0']),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, _hoisted_4, 2))
        : (_openBlock(), _createBlock(_component_CircleLoader, {
            key: 1,
            color: _ctx.LoaderColor.blue,
            class: "right-2"
          }, null, 8, ["color"]))
    ], 2)
  ]))
}